import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { $api, errorHandler, globalConst } from '../../global';

export const useStartDtmTest = () => {
  const { push } = useRouter();

  return useMutation({
    mutationFn: async (data: {
      language_id: number;
      blok?: number;
      blok_1?: number;
      blok_2?: number;
      blok_3?: number;
      year_id?: number | null;
    }) => {
      const res = await $api.post('/dtm-order', data);

      return res.data;
    },
    onSuccess: () => {
      push(globalConst.pageNames.DTM_TEST);
    },
    onError: errorHandler()
  });
};
